export default __webpack_public_path__ + "img/17f82e786e6f8b5d1f3b39b067e9efe2.jpg";